var map = {
	"./home.js": "W27U",
	"./index.js": "8NmS",
	"./invest.js": "1I4+",
	"./mistakes.js": "1i8f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D84C";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules \.js
// module id = D84C
// module chunks = 25